import React, { useEffect, useState } from "react";
import PaymentIcon from "@mui/icons-material/Payment";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrder,
  resetAllActions,
  updateOrderPayment,
} from "../../State/Order/Action";
import { RAZORPAY_KEY_ID } from "../../services/api";
import { useNavigate } from "react-router-dom";

const ProceedToBuyButton = ({ cartId, disabled }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dialogMessage, setDialogMessage] = useState("");
  const [showFailureDialog, setShowFailureDialog] = useState(false);

  const {
    createOrderResult,
    loading,
    errorCreate,
    updateOrderPaymentResult,
    loadingUpdateOrderPayment,
    errorUpdateOrderPayment,
  } = useSelector((state) => state.order);

  const handleProceedToBuy = () => {
    if (cartId) {
      dispatch(createOrder({ cartId }));
    } else {
      setDialogMessage("Your cart is empty. Please add courses to proceed.");
      setShowFailureDialog(true);
    }
  };

  useEffect(() => {
    if (createOrderResult && createOrderResult.success === true) {
      handlePayment(createOrderResult?.data);
    } else if (createOrderResult && createOrderResult.success === false) {
      setDialogMessage(createOrderResult.message);
      setShowFailureDialog(true);
    }
  }, [createOrderResult]);

  useEffect(() => {
    if (errorCreate) {
      setDialogMessage(errorCreate);
      setShowFailureDialog(true);
    }
    dispatch(resetAllActions());
  }, [errorCreate]);

  useEffect(() => {
    if (updateOrderPaymentResult) {
      if (updateOrderPaymentResult.success && updateOrderPaymentResult.data) {
        setDialogMessage("Payment updated successfully!");
        navigate("/order-detail/" + updateOrderPaymentResult.data);
      } else {
        setDialogMessage(
          updateOrderPaymentResult.message || "Payment update failed."
        );
      }
      setShowFailureDialog(true);

      // ✅ Reset after payment update is fully handled
      dispatch(resetAllActions());
    }
  }, [updateOrderPaymentResult]);

  const handlePayment = (order) => {
    try {
      const options = {
        key: RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency,
        name: "Vicademics Software",
        description: "Course Purchase",
        order_id: order.paymentGatewayOrderId,
        handler: function (response) {
          const paymentData = {
            pgPaymentId: response.razorpay_payment_id,
            pgOrderId: response.razorpay_order_id,
            pgSignature: response.razorpay_signature,
          };
          dispatch(updateOrderPayment(order.orderId, paymentData));
        },
        prefill: {
          name: order.learnerName,
          email: order.learnerEmail,
          contact: order.learnerPhone,
        },
        notes: {
          address: order.billingAddress,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error(error);
      alert("Something went wrong while initiating payment");
    }
  };

  return (
    <Button
      variant="contained"
      color="success"
      fullWidth
      endIcon={<PaymentIcon />}
      sx={{ borderRadius: 2, fontWeight: "bold" }}
      onClick={handleProceedToBuy}
      disabled={disabled || loading || loadingUpdateOrderPayment}
    >
      Proceed to Buy
    </Button>
  );
};

export default ProceedToBuyButton;
